import Cookies from 'js-cookie'
import Vue from 'vue'
import Vuex from 'vuex'
import moment from 'moment'

Vue.use(Vuex)

const pubJs = {
  computed: {
    // 获取app-main内容区域的高度
    get_appmain_H() {
      let win_h = document.documentElement.clientHeight;
      let height = win_h - 125;
      return height;
    },
    BUILD_ENV() {
      return process.env.BUILD_ENV
    }
  },
  methods: {
    NoSpacesAllowed(val) {
      let reg = /\s+/g;
      let result = val.replace(reg, '');
      return result
    },
    IsEmpty(val) {
      if (val === null || val === '' || val === undefined || val === 'undefined') {
        return null
      } else {
        return val
      }
    },
    // 二进制流文件下载
    blobDownload(res,fileName) {
      let objectUrl = window.URL.createObjectURL(res);
      let a = document.createElement('a');
      a.href = objectUrl;
      a.download = fileName;
      a.click()
      a.remove();
    },
    numberFormat(value) {
      if (!value) {
          return '0'
      }
      const intPartFormat = value.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,') // 将整数部分逢三一断
      return intPartFormat
    }
  },
  filters: {
    formatDate(val, pattern="YYYY-MM-DD") {
      return moment(val).format(pattern)
    }
  }
};

export default pubJs
